import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import { MenuItem } from '../models/rich-data.model';

@Pipe({
  name: 'isOpen'
})
export class IsOpenPipe implements PipeTransform {

  transform(
    day: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday',
    menuItem: MenuItem, type: 'day' | 'hour'): boolean {

    let dayOpen = false;
    let hourOpen = false;

    if (menuItem && menuItem.menu_item_books) {
      menuItem.menu_item_books.forEach(book => {
        if (book[day]) {
          dayOpen = true;

          if (book.menu_item_book_details) {
            book.menu_item_book_details.forEach(detail => {
              const UTC = dayjs(new Date()).utcOffset();

              const START = dayjs(new Date()).set('hour', +dayjs(detail.start_time).format('HH'))
                .set('minutes', +dayjs(detail.start_time).format('mm')).set('seconds', 0).set('millisecond', 0)
                .add(-UTC, 'minutes');

              let END = dayjs(new Date()).set('hour', +dayjs(detail.end_time).format('HH'))
                .set('minutes', +dayjs(detail.end_time).format('mm')).set('seconds', 0).set('millisecond', 0)
                .add(-UTC, 'minutes');

              if (dayjs(END).diff(START) < 0) {
                END = END.add(1, 'days');
              }

              if (dayjs(new Date()).diff(START) > 0 && dayjs(new Date()).diff(END) < 0) {
                hourOpen = true;
              }

            });
          }
        }
      });
    }

    return type === 'day' ? dayOpen : hourOpen;
  }

}
